module.exports = __webpack_public_path__ + "media/entities/3003-f972aecb.png";